import { render, staticRenderFns } from "./RecruiterCompanyAvatar.vue?vue&type=template&id=648cceae&scoped=true"
import script from "./RecruiterCompanyAvatar.vue?vue&type=script&lang=ts"
export * from "./RecruiterCompanyAvatar.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterCompanyAvatar.vue?vue&type=style&index=0&id=648cceae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cceae",
  null
  
)

export default component.exports